export const EXP_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  preparado: { label: "Preparado", tone: "info" },
  en_curso: { label: "En curso", tone: "info" },
  esperando_informacion: { label: "Esperando información", tone: "warning" },
  esperando_evidencia: { label: "Esperando evidencia", tone: "warning" },
  esperando_revision: { label: "Esperando revisión", tone: "warning" },
  esperando_aprobacion: { label: "Esperando aprobación", tone: "ai" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  completado: { label: "Completado", tone: "success" },
  cancelado: { label: "Cancelado", tone: "muted" },
};

export const TASK_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  en_curso: { label: "En curso", tone: "info" },
  esperando: { label: "Esperando", tone: "warning" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
  en_revision: { label: "En revisión", tone: "ai" },
  completada: { label: "Completada", tone: "success" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const EV_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  solicitada: { label: "Solicitada", tone: "info" },
  aportada: { label: "Aportada", tone: "info" },
  en_revision: { label: "En revisión", tone: "warning" },
  aceptada: { label: "Aceptada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  caducada: { label: "Caducada", tone: "muted" },
};

export const APPR_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  solicitada: { label: "Solicitada", tone: "warning" },
  en_revision: { label: "En revisión", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  cambios_solicitados: { label: "Cambios solicitados", tone: "warning" },
  cancelada: { label: "Cancelada", tone: "muted" },
  caducada: { label: "Caducada", tone: "muted" },
};

export const AI_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  procesando: { label: "Procesando", tone: "info" },
  resultado_disponible: { label: "Resultado disponible", tone: "info" },
  requiere_validacion: { label: "Requiere validación", tone: "danger" },
  validado: { label: "Validado", tone: "success" },
  corregido: { label: "Corregido", tone: "warning" },
  rechazado: { label: "Rechazado", tone: "danger" },
};

export const RISK = {
  bajo: { label: "Bajo", tone: "success" },
  medio: { label: "Medio", tone: "info" },
  alto: { label: "Alto", tone: "warning" },
  critico: { label: "Crítico", tone: "danger" },
};

export const PRIORITY = {
  baja: { label: "Baja", tone: "muted" },
  media: { label: "Media", tone: "info" },
  alta: { label: "Alta", tone: "warning" },
  urgente: { label: "Urgente", tone: "danger" },
};

export const COMM_TYPE = {
  email_recibido: "Email recibido",
  email_enviado: "Email enviado",
  teams: "Mensaje Teams",
  firma: "Notificación de firma",
  administrativa: "Comunicación administrativa",
  interno: "Mensaje interno",
};

export const ACTIVITY_LABELS = {
  expediente_creado: "Expediente creado",
  proceso_iniciado: "Proceso iniciado",
  paso_activado: "Paso activado",
  proceso_finalizado: "Proceso finalizado",
  tarea_creada: "Tarea creada",
  tarea_completada: "Tarea completada",
  estado_modificado: "Estado modificado",
  evidencia_solicitada: "Evidencia solicitada",
  evidencia_aportada: "Evidencia aportada",
  evidencia_aceptada: "Evidencia aceptada",
  evidencia_rechazada: "Evidencia rechazada",
  aprobacion_solicitada: "Aprobación solicitada",
  aprobacion_concedida: "Aprobación concedida",
  aprobacion_rechazada: "Aprobación rechazada",
  aprobacion_cambios: "Cambios solicitados",
  comunicacion_recibida: "Comunicación recibida",
  comunicacion_enviada: "Comunicación enviada",
  comunicacion_relacionada: "Comunicación relacionada",
  comunicacion_archivada: "Comunicación archivada",
  ia_generado: "Análisis IA generado",
  ia_validado: "Análisis IA revisado",
  bloqueo_creado: "Bloqueo creado",
  bloqueo_resuelto: "Bloqueo resuelto",
  expediente_completado: "Expediente completado",
  documento_cargado: "Documento cargado",
  documento_nueva_version: "Nueva versión de documento",
  documento_archivado: "Documento archivado",
  revision_aprobada: "Revisión aprobada",
  revision_devuelta: "Revisión devuelta",
  comentario: "Comentario",
  login: "Inicio de sesión",
  demo_restaurada: "Datos demo restaurados",
  expediente_asignado: "Expediente asignado",
  planning_importado: "Planning importado",
  planning_revisado: "Planning revisado",
  planning_en_aprobacion: "Planning enviado a aprobación",
  planning_aprobado: "Planning aprobado",
  planning_rechazado: "Planning devuelto",
  planning_publicado: "Planning publicado",
  planning_descartado: "Versión de planning descartada",
  avance_actualizado: "Avance actualizado",
  riesgo_retraso_creado: "Riesgo de retraso registrado",
  riesgos_retraso_detectados: "Riesgos de retraso detectados",
  hito_critico_retrasado: "Hito crítico retrasado",
  recovery_plan_generado: "Plan de recuperación generado (IA)",
  recovery_revisado: "Plan de recuperación revisado",
  recovery_aprobado: "Plan de recuperación aprobado",
  recovery_incorporado: "Plan de recuperación incorporado",
  recurso_sobreasignado: "Recurso sobreasignado",
  cobro_registrado: "Cobro registrado",
  comparacion_creada: "Comparación creada",
  comparacion_ejecutada: "Comparación ejecutada",
  contrato_recibido: "Contrato recibido",
  contrato_vinculado: "Contrato vinculado",
  control_actualizado: "Fecha de control actualizada",
  cuenta_cambiada: "Cuenta bancaria modificada",
  disputa_creada: "Disputa registrada",
  excepcion_detectada: "Excepción de matching detectada",
  factura_recibida: "Factura recibida",
  forecast_actualizado: "Forecast actualizado",
  gate_aprobada: "Puerta de fase aprobada",
  gate_rechazada: "Puerta de fase devuelta",
  hitos_creados: "Hitos creados",
  movimiento_presupuesto: "Movimiento presupuestario",
  obligacion_creada: "Obligación creada",
  occurrence_creada: "Ocurrencia de obligación creada",
  planning_actualizado: "Planning actualizado",
  proyecto_creado: "Proyecto creado",
  proyecto_en_riesgo: "Proyecto en riesgo",
  remesa_exportada: "Remesa exportada",
  riesgo_creado: "Riesgo registrado",
  reconciliacion_economica: "Reconciliación económica",
  seed_economics: "Seed económico",
  cambio_solicitado: "Cambio solicitado",
  cambio_analizado: "Cambio analizado",
  cambio_en_revision: "Cambio en revisión",
  cambio_en_aprobacion: "Cambio enviado a aprobación",
  cambio_aprobado: "Cambio aprobado",
  cambio_rechazado: "Cambio rechazado",
  cambio_incorporado: "Cambio incorporado al presupuesto",
  forecast_creado: "Forecast creado",
  forecast_aprobado: "Forecast aprobado",
  forecast_descartado: "Forecast descartado",
  certificacion_recibida: "Certificación recibida",
  certificacion_validada: "Certificación validada",
  certificacion_revision_tecnica: "Certificación — revisión técnica",
  certificacion_revision_economica: "Certificación — revisión económica",
  certificacion_aprobada: "Certificación aprobada",
  certificacion_rechazada: "Certificación rechazada",
  certificacion_devuelta: "Certificación devuelta",
  riesgo_analizar: "Riesgo en análisis",
  riesgo_gestionar: "Riesgo en gestión",
  riesgo_cerrar: "Riesgo/incidencia cerrado",
  riesgo_materializado: "Riesgo materializado en incidencia",
  incidencia_creada: "Incidencia registrada",
  decision_propuesta: "Decisión propuesta",
  decision_evaluar: "Decisión en evaluación",
  decision_aprobar: "Decisión aprobada",
  decision_rechazar: "Decisión rechazada",
  decision_implementar: "Decisión implementada",
  inspeccion_programada: "Inspección programada",
  inspeccion_realizar: "Inspección realizada",
  inspeccion_validar: "Inspección validada",
  inspeccion_cerrar: "Inspección cerrada",
  hallazgo_creado: "Hallazgo de calidad registrado",
  ncr_validar: "Hallazgo validado",
  ncr_elevar_ncr: "No conformidad declarada",
  ncr_iniciar_accion: "Acción correctiva iniciada",
  ncr_aportar_evidencia: "Evidencia de NCR aportada",
  ncr_solicitar_verificacion: "Verificación de NCR solicitada",
  ncr_verificar_cierre: "NCR verificada y cerrada",
  ncr_reabrir: "NCR reabierta",
  ncr_descartar: "Hallazgo descartado",
  vision_candidato: "Candidato de visión IA propuesto",
  vision_confirmado: "Candidato de visión confirmado (humano)",
  vision_descartado: "Candidato de visión descartado (humano)",
  permiso_identificado: "Permiso identificado",
  permiso_documentar: "Permiso en documentación",
  permiso_revisar: "Permiso en revisión",
  permiso_presentar: "Permiso presentado",
  permiso_tramitar: "Permiso en tramitación",
  permiso_recibir_requerimiento: "Requerimiento de permiso recibido",
  permiso_responder: "Respuesta a requerimiento",
  permiso_resolver: "Resolución de permiso",
  permiso_condicionar: "Condiciones de permiso registradas",
  permiso_cerrar: "Permiso cerrado",
  acometida_solicitada: "Acometida solicitada",
  acometida_recibir_oferta: "Oferta de acometida recibida",
  acometida_aprobar: "Acometida aprobada",
  acometida_iniciar_ejecucion: "Acometida en ejecución",
  acometida_documentar: "Acometida documentada",
  acometida_probar: "Prueba de acometida registrada",
  acometida_conectar: "Acometida conectada",
  acometida_poner_en_servicio: "Acometida en servicio",
  sys_documento_registrado: "Documento SyS registrado",
  sys_aportar: "Documento SyS aportado",
  sys_revisar_ok: "Documento SyS validado",
  sys_rechazar: "Documento SyS rechazado",
  reporting_abierto: "Periodo de reporting abierto",
  reporting_solicitar_actualizaciones: "Actualizaciones de reporting solicitadas",
  reporting_generar_borrador: "Borrador IA de informe generado",
  reporting_enviar_revision: "Informe enviado a revisión",
  reporting_solicitar_aprobacion: "Informe enviado a aprobación",
  reporting_aprobado: "Informe mensual aprobado",
  reporting_devuelto: "Informe devuelto a revisión",
  reporting_emitir: "Informe emitido (snapshot)",
  reporting_cerrar: "Periodo de reporting cerrado",
  automatizacion: "Automatización ejecutada",
  seed_ops: "Seed operativa Hito 4",
};

export const AREAS = [
  "General", "Corporativo", "Advisory", "Legal", "Proyectos", "Administración",
  "Técnico", "Asset Management", "Business Development",
];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short" }) + " " + d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
};

export const isOverdue = (iso) => iso && new Date(iso) < new Date();

export const CONTRACT_STATUS = {
  recibido: { label: "Recibido", tone: "muted" },
  pendiente_clasificacion: { label: "Pendiente de clasificación", tone: "muted" },
  analisis_ia: { label: "En análisis IA", tone: "ai" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  revision_juridica: { label: "En revisión jurídica", tone: "info" },
  revision_negocio: { label: "En revisión de negocio", tone: "info" },
  revision_financiera: { label: "En revisión financiera", tone: "info" },
  cambios_solicitados: { label: "Cambios solicitados", tone: "warning" },
  preparado_aprobacion: { label: "Preparado para aprobación", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobado: { label: "Aprobado", tone: "success" },
  preparado_firma: { label: "Preparado para firma", tone: "info" },
  enviado_firma: { label: "Enviado a firma", tone: "ai" },
  parcialmente_firmado: { label: "Parcialmente firmado", tone: "warning" },
  firmado: { label: "Firmado", tone: "success" },
  activo: { label: "Activo", tone: "success" },
  proximo_vencimiento: { label: "Próximo a vencimiento", tone: "warning" },
  revision_renovacion: { label: "En revisión de renovación", tone: "warning" },
  renovacion_aprobada: { label: "Renovación aprobada", tone: "success" },
  terminacion_en_curso: { label: "Terminación en curso", tone: "danger" },
  expirado: { label: "Expirado", tone: "muted" },
  terminado: { label: "Terminado", tone: "muted" },
  archivado: { label: "Archivado", tone: "muted" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  cancelado: { label: "Cancelado", tone: "muted" },
};

export const OCC_STATUS = {
  candidata: { label: "Candidata", tone: "muted" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  activa: { label: "Activa", tone: "info" },
  programada: { label: "Programada", tone: "muted" },
  proxima: { label: "Próxima", tone: "warning" },
  pendiente_evidencia: { label: "Pendiente de evidencia", tone: "warning" },
  evidencia_en_revision: { label: "Evidencia en revisión", tone: "ai" },
  cumplida: { label: "Cumplida", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  vencida: { label: "Vencida", tone: "danger" },
  incumplimiento_potencial: { label: "Incumplimiento potencial", tone: "danger" },
  exonerada: { label: "Exonerada", tone: "muted" },
  suspendida: { label: "Suspendida", tone: "muted" },
  cancelada: { label: "Cancelada", tone: "muted" },
  sustituida: { label: "Sustituida", tone: "muted" },
};

export const SIG_STATUS = {
  preparado: { label: "Preparado", tone: "muted" },
  enviado: { label: "Enviado", tone: "info" },
  entregado: { label: "Entregado", tone: "info" },
  visualizado: { label: "Visualizado", tone: "info" },
  parcialmente_firmado: { label: "Parcialmente firmado", tone: "warning" },
  firmado: { label: "Firmado", tone: "success" },
  completado: { label: "Completado", tone: "success" },
  rechazado: { label: "Rechazado", tone: "danger" },
  cancelado: { label: "Cancelado", tone: "muted" },
  expirado: { label: "Expirado", tone: "muted" },
  error: { label: "Error", tone: "danger" },
};

export const RISK_FINDING_STATUS = {
  detectado: { label: "Detectado", tone: "warning" },
  pendiente_revision: { label: "Pendiente de revisión", tone: "warning" },
  confirmado: { label: "Confirmado", tone: "danger" },
  mitigacion_requerida: { label: "Mitigación requerida", tone: "danger" },
  aceptado: { label: "Aceptado", tone: "info" },
  resuelto: { label: "Resuelto", tone: "success" },
  falso_positivo: { label: "Falso positivo", tone: "muted" },
};

export const MILESTONE_STATUS = {
  previsto: { label: "Previsto", tone: "muted" },
  proximo: { label: "Próximo", tone: "warning" },
  preparado_facturar: { label: "Preparado para facturar", tone: "info" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  facturado: { label: "Facturado", tone: "success" },
  cancelado: { label: "Cancelado", tone: "muted" },
};

export const CLAUSE_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  en_revision: { label: "En revisión", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  retirada: { label: "Retirada", tone: "danger" },
  sustituida: { label: "Sustituida", tone: "muted" },
};

export const PROJECT_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  activo: { label: "Activo", tone: "success" },
  en_riesgo: { label: "En riesgo", tone: "warning" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  en_pausa: { label: "En pausa", tone: "muted" },
  en_cierre: { label: "En cierre", tone: "info" },
  completado: { label: "Completado", tone: "success" },
  cancelado: { label: "Cancelado", tone: "muted" },
  archivado: { label: "Archivado", tone: "muted" },
};

export const PHASE_LABELS = {
  inicio: "Inicio", viabilidad: "Viabilidad", diseno: "Diseño", licitacion: "Licitación",
  contratacion: "Contratación", licencias: "Licencias", construccion: "Construcción",
  puesta_marcha: "Puesta en marcha", entrega: "Entrega", cierre: "Cierre",
};
export const LIFECYCLE_PHASES = ["inicio", "viabilidad", "diseno", "licitacion", "contratacion", "licencias", "construccion", "puesta_marcha", "entrega", "cierre"];

export const PROJECT_HEALTH = {
  verde: { label: "En verde", tone: "success" },
  ambar: { label: "En ámbar", tone: "warning" },
  rojo: { label: "En rojo", tone: "danger" },
  gris: { label: "Sin datos", tone: "muted" },
};

export const GATE_STATUS = {
  no_iniciada: { label: "No iniciada", tone: "muted" },
  en_preparacion: { label: "En preparación", tone: "info" },
  lista_revision: { label: "Lista para revisión", tone: "warning" },
  en_revision: { label: "En revisión", tone: "ai" },
  cambios_requeridos: { label: "Cambios requeridos", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  no_aplicable: { label: "No aplicable", tone: "muted" },
};

export const DATA_QUALITY = {
  completo: { label: "Completo", tone: "success" },
  completo_advertencias: { label: "Completo con advertencias", tone: "warning" },
  incompleto: { label: "Incompleto", tone: "danger" },
  desactualizado: { label: "Desactualizado", tone: "warning" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
};

export const fmtMoney = (v, currency = "EUR") => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency, maximumFractionDigits: 2 }).format(Number(v));
};

// Formato ejecutivo abreviado: 19,3 M€ / 680.000 € (el valor subyacente no cambia)
export const fmtMoneyShort = (v) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  if (Math.abs(n) >= 1e6) return `${new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(n / 1e6)} M€`;
  return `${new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(n)} €`;
};

// Fecha corta española: 4 sep 2026
export const fmtDateShort = (iso) => {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-ES", { day: "numeric", month: "short", year: "numeric" }).format(new Date(iso)).replace(".", "");
};

export const SUPPLIER_STATUS = {
  candidato: { label: "Candidato", tone: "muted" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  activo: { label: "Activo", tone: "success" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  suspendido: { label: "Suspendido", tone: "danger" },
  inactivo: { label: "Inactivo", tone: "muted" },
};

export const BANK_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  pendiente_verificacion: { label: "Pendiente de verificación", tone: "warning" },
  verificada: { label: "Verificada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  sustituida: { label: "Sustituida", tone: "muted" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};

export const QUOTE_STATUS = {
  recibida: { label: "Recibida", tone: "muted" },
  en_extraccion: { label: "En extracción", tone: "ai" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  validada: { label: "Validada", tone: "info" },
  en_comparacion: { label: "En comparación", tone: "ai" },
  seleccionada: { label: "Seleccionada", tone: "success" },
  no_seleccionada: { label: "No seleccionada", tone: "muted" },
  caducada: { label: "Caducada", tone: "muted" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const PR_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  preparada: { label: "Preparada", tone: "info" },
  en_revision: { label: "En revisión", tone: "info" },
  pendiente_presupuesto: { label: "Pendiente de presupuesto", tone: "danger" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada: { label: "Aprobada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  convertida_orden: { label: "Convertida en orden", tone: "success" },
  cancelada: { label: "Cancelada", tone: "muted" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};

export const PO_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_revision: { label: "Pendiente de revisión", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada: { label: "Aprobada", tone: "success" },
  preparada_emision: { label: "Preparada para emisión", tone: "info" },
  emitida: { label: "Emitida", tone: "info" },
  recibida_proveedor: { label: "Recibida por proveedor", tone: "info" },
  confirmada: { label: "Confirmada", tone: "success" },
  parcialmente_ejecutada: { label: "Parcialmente ejecutada", tone: "warning" },
  ejecutada: { label: "Ejecutada", tone: "success" },
  cerrada: { label: "Cerrada", tone: "muted" },
  cancelada: { label: "Cancelada", tone: "muted" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};

export const RECEIPT_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  parcial: { label: "Parcial", tone: "warning" },
  recibida: { label: "Recibida", tone: "info" },
  pendiente_revision: { label: "Pendiente de revisión", tone: "warning" },
  aceptada: { label: "Aceptada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  con_reservas: { label: "Con reservas", tone: "warning" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const INVOICE_STATUS = {
  recibida: { label: "Recibida", tone: "muted" },
  en_extraccion: { label: "En extracción", tone: "ai" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  en_matching: { label: "En matching", tone: "ai" },
  con_advertencias: { label: "Con advertencias", tone: "warning" },
  con_excepcion: { label: "Con excepción", tone: "danger" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  pendiente_conformidad: { label: "Pendiente de conformidad", tone: "warning" },
  preparada_aprobacion: { label: "Preparada para aprobación", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada: { label: "Aprobada", tone: "success" },
  preparada_pago: { label: "Preparada para pago", tone: "info" },
  incluida_remesa: { label: "Incluida en remesa", tone: "info" },
  enviada_pago: { label: "Enviada a pago", tone: "info" },
  pagada: { label: "Pagada", tone: "success" },
  pendiente_conciliacion: { label: "Pendiente de conciliación", tone: "warning" },
  conciliada: { label: "Conciliada", tone: "success" },
  parcialmente_pagada: { label: "Parcialmente pagada", tone: "warning" },
  disputada: { label: "Disputada", tone: "danger" },
  rechazada: { label: "Rechazada", tone: "danger" },
  anulada: { label: "Anulada", tone: "muted" },
  abonada: { label: "Abonada", tone: "muted" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};

export const EXCEPTION_STATUS = {
  detectada: { label: "Detectada", tone: "danger" },
  asignada: { label: "Asignada", tone: "warning" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  pendiente_correccion: { label: "Pendiente de corrección", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  resuelta: { label: "Resuelta", tone: "success" },
  aceptada_excepcionalmente: { label: "Aceptada excepcionalmente", tone: "info" },
  rechazada: { label: "Rechazada", tone: "muted" },
  escalada: { label: "Escalada", tone: "danger" },
};

export const BATCH_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  en_validacion: { label: "En validación", tone: "warning" },
  con_errores: { label: "Con errores", tone: "danger" },
  preparada_aprobacion: { label: "Preparada para aprobación", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada: { label: "Aprobada", tone: "success" },
  exportada: { label: "Exportada", tone: "info" },
  enviada: { label: "Enviada", tone: "info" },
  aceptada: { label: "Aceptada", tone: "info" },
  parcialmente_rechazada: { label: "Parcialmente rechazada", tone: "danger" },
  ejecutada: { label: "Ejecutada", tone: "success" },
  pendiente_conciliacion: { label: "Pendiente de conciliación", tone: "warning" },
  conciliada: { label: "Conciliada", tone: "success" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const CLIENT_INV_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada_emision: { label: "Aprobada para emisión", tone: "info" },
  enviada_erp: { label: "Enviada a ERP", tone: "info" },
  emitida: { label: "Emitida", tone: "info" },
  enviada_cliente: { label: "Enviada al cliente", tone: "info" },
  vencida: { label: "Vencida", tone: "danger" },
  parcialmente_cobrada: { label: "Parcialmente cobrada", tone: "warning" },
  cobrada: { label: "Cobrada", tone: "success" },
  disputada: { label: "Disputada", tone: "danger" },
  anulada: { label: "Anulada", tone: "muted" },
  abonada: { label: "Abonada", tone: "muted" },
};

export const BILLING_ITEM_STATUS = {
  previsto: { label: "Previsto", tone: "muted" },
  proximo: { label: "Próximo", tone: "warning" },
  pendiente_evidencia: { label: "Pendiente de evidencia", tone: "warning" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "ai" },
  preparado_facturar: { label: "Preparado para facturar", tone: "info" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  facturado: { label: "Facturado", tone: "success" },
  cancelado: { label: "Cancelado", tone: "muted" },
};

export const EXC_SEVERITY = {
  critica: { label: "Crítica", tone: "danger" },
  alta: { label: "Alta", tone: "warning" },
  media: { label: "Media", tone: "info" },
  baja: { label: "Baja", tone: "muted" },
};

export const CONTROL_RESULT = {
  superado: { label: "Superado", tone: "success" },
  fallido: { label: "Fallido", tone: "danger" },
  advertencia: { label: "Advertencia", tone: "warning" },
  pendiente: { label: "Pendiente", tone: "muted" },
  no_aplicable: { label: "No aplicable", tone: "muted" },
};

export const CONFIDENCE = {
  alta: { label: "Alta", tone: "success" },
  media: { label: "Media", tone: "warning" },
  baja: { label: "Baja", tone: "danger" },
  sin_dato: { label: "NO IDENTIFICADO", tone: "muted" },
};

export const PLAN_VERSION_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  en_validacion: { label: "En validación", tone: "info" },
  con_errores: { label: "Con errores", tone: "danger" },
  pendiente_revision: { label: "Pendiente de revisión", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  vigente: { label: "Vigente", tone: "success" },
  sustituida: { label: "Sustituida", tone: "muted" },
  descartada: { label: "Descartada", tone: "muted" },
};

export const PLAN_VERSION_KIND = {
  baseline: { label: "Baseline", tone: "info" },
  actualizacion: { label: "Actualización", tone: "muted" },
};

export const PLAN_ACT_STATUS = {
  no_iniciada: { label: "No iniciada", tone: "muted" },
  en_curso: { label: "En curso", tone: "info" },
  completada: { label: "Completada", tone: "success" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};

export const PLAN_MILESTONE_STATUS = {
  previsto: { label: "Previsto", tone: "muted" },
  en_riesgo: { label: "En riesgo", tone: "warning" },
  retrasado: { label: "Retrasado", tone: "danger" },
  cumplido: { label: "Cumplido", tone: "success" },
};

export const SCHEDULE_RISK_STATUS = {
  identificado: { label: "Identificado", tone: "warning" },
  en_analisis: { label: "En análisis", tone: "info" },
  accion_en_curso: { label: "Acción en curso", tone: "info" },
  mitigado: { label: "Mitigado", tone: "success" },
  cerrado: { label: "Cerrado", tone: "muted" },
};

export const RECOVERY_PLAN_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  en_revision: { label: "En revisión", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "warning" },
  aprobado: { label: "Aprobado", tone: "success" },
  rechazado: { label: "Rechazado", tone: "danger" },
  incorporado: { label: "Incorporado al planning", tone: "info" },
};

export const DEP_TYPE = {
  FS: { label: "FS", desc: "Fin → Inicio: la sucesora empieza cuando termina la predecesora" },
  SS: { label: "SS", desc: "Inicio → Inicio: la sucesora empieza cuando empieza la predecesora" },
  FF: { label: "FF", desc: "Fin → Fin: la sucesora termina cuando termina la predecesora" },
  SF: { label: "SF", desc: "Inicio → Fin: la sucesora termina cuando empieza la predecesora" },
};

export const RISK_SEVERITY = {
  critica: { label: "Crítica", tone: "danger" },
  alta: { label: "Alta", tone: "warning" },
  media: { label: "Media", tone: "info" },
  baja: { label: "Baja", tone: "muted" },
};

export const fmtDays = (d) => (d == null ? "—" : d > 0 ? `+${d} días` : d < 0 ? `${d} días` : "0");

export const CHANGE_STATUS = {
  solicitado: { label: "Solicitado", tone: "warning" },
  en_analisis: { label: "En análisis", tone: "info" },
  en_revision: { label: "En revisión", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "warning" },
  aprobado: { label: "Aprobado", tone: "success" },
  incorporado: { label: "Incorporado", tone: "success" },
  rechazado: { label: "Rechazado", tone: "danger" },
};

export const FORECAST_V_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "warning" },
  aprobada: { label: "Aprobada (inmutable)", tone: "success" },
  sustituida: { label: "Sustituida", tone: "muted" },
  descartada: { label: "Descartada", tone: "muted" },
};

export const CERT_STATUS = {
  recibida: { label: "Recibida", tone: "muted" },
  en_extraccion: { label: "En extracción", tone: "info" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  revision_tecnica: { label: "Revisión técnica", tone: "info" },
  revision_economica: { label: "Revisión económica", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  aprobada_parcial: { label: "Aprobada parcial", tone: "warning" },
  rechazada: { label: "Rechazada", tone: "danger" },
};

export const LEDGER_STAGE = {
  presupuesto: { label: "Presupuesto", tone: "info" },
  compromiso: { label: "Compromiso", tone: "warning" },
  compromiso_detalle: { label: "Ejecución de contrato (no suma compromiso)", tone: "muted" },
  certificado: { label: "Certificado", tone: "success" },
  facturado: { label: "Facturado", tone: "info" },
  pagado: { label: "Pagado", tone: "success" },
};

export const LEDGER_SOURCE = {
  budget_line: "Partida presupuestaria",
  change: "Cambio de proyecto",
  contract: "Contrato",
  po: "Orden de compra",
  certification: "Certificación",
  invoice: "Factura",
  payment: "Pago",
};

export const fmtEUR = (n) => (n == null ? "—" : `${Number(n).toLocaleString("es-ES", { maximumFractionDigits: 0 })} €`);

// ---------------- HITO 4 — OPERATIVA ----------------
export const ITEM_KIND = {
  risk: { label: "Riesgo", tone: "warning" },
  issue: { label: "Incidencia", tone: "danger" },
};

export const RISK_STATUS = {
  identificado: { label: "Identificado", tone: "warning" },
  en_analisis: { label: "En análisis", tone: "info" },
  en_gestion: { label: "En gestión", tone: "info" },
  cerrado: { label: "Cerrado", tone: "muted" },
};

export const DECISION_STATUS = {
  propuesta: { label: "Propuesta", tone: "muted" },
  en_evaluacion: { label: "En evaluación", tone: "info" },
  aprobada: { label: "Aprobada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  implementada: { label: "Implementada", tone: "success" },
};

export const INSPECTION_STATUS = {
  programada: { label: "Programada", tone: "muted" },
  realizada: { label: "Realizada", tone: "info" },
  validada: { label: "Validada", tone: "success" },
  cerrada: { label: "Cerrada", tone: "muted" },
};

export const FINDING_STATUS = {
  hallazgo: { label: "Hallazgo", tone: "warning" },
  validado: { label: "Validado", tone: "info" },
  no_conformidad: { label: "No conformidad", tone: "danger" },
  accion_correctiva: { label: "Acción correctiva", tone: "info" },
  evidencia_aportada: { label: "Evidencia aportada", tone: "info" },
  en_verificacion: { label: "En verificación", tone: "ai" },
  cerrada: { label: "Cerrada", tone: "success" },
  descartado: { label: "Descartado", tone: "muted" },
};

export const VISION_STATUS = {
  pendiente_revision: { label: "Pendiente de revisión humana", tone: "ai" },
  confirmado: { label: "Confirmado (humano)", tone: "success" },
  descartado: { label: "Descartado (humano)", tone: "muted" },
};

export const PERMIT_STATUS = {
  identificado: { label: "Identificado", tone: "muted" },
  documentacion: { label: "Documentación", tone: "info" },
  revision: { label: "Revisión interna", tone: "info" },
  presentado: { label: "Presentado", tone: "info" },
  tramitacion: { label: "En tramitación", tone: "warning" },
  requerimiento: { label: "Requerimiento recibido", tone: "danger" },
  respuesta: { label: "Respuesta al requerimiento", tone: "info" },
  resolucion: { label: "Resolución", tone: "ai" },
  condiciones: { label: "Condiciones posteriores", tone: "warning" },
  cerrado: { label: "Cerrado", tone: "success" },
};

export const UTILITY_STATUS = {
  solicitud: { label: "Solicitud", tone: "muted" },
  oferta: { label: "Oferta recibida", tone: "info" },
  aprobada: { label: "Aprobada", tone: "success" },
  ejecucion: { label: "En ejecución", tone: "info" },
  documentacion: { label: "Documentación", tone: "info" },
  prueba: { label: "Prueba", tone: "warning" },
  conexion: { label: "Conexión", tone: "warning" },
  en_servicio: { label: "En servicio", tone: "success" },
};

export const SAFETY_DOC_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  aportado: { label: "Aportado", tone: "info" },
  en_revision: { label: "En revisión", tone: "info" },
  valido: { label: "Válido", tone: "success" },
  caducado: { label: "Caducado", tone: "danger" },
  rechazado: { label: "Rechazado", tone: "danger" },
};

export const REPORT_STATUS = {
  abierto: { label: "Periodo abierto", tone: "info" },
  recopilacion: { label: "Recopilación", tone: "info" },
  borrador_ia: { label: "Borrador IA", tone: "ai" },
  revision: { label: "En revisión", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobado: { label: "Aprobado", tone: "success" },
  emitido: { label: "Emitido (snapshot)", tone: "success" },
  cerrado: { label: "Cerrado", tone: "muted" },
};

export const STATEMENT_NATURE = {
  dato: { label: "Dato", tone: "info" },
  analisis: { label: "Análisis", tone: "ai" },
  hipotesis: { label: "Hipótesis", tone: "warning" },
  recomendacion: { label: "Recomendación", tone: "warning" },
  no_verificada: { label: "No verificada", tone: "danger" },
};

export const SEVERITY = {
  baja: { label: "Baja", tone: "muted" }, media: { label: "Media", tone: "info" },
  alta: { label: "Alta", tone: "warning" }, critica: { label: "Crítica", tone: "danger" },
  menor: { label: "Menor", tone: "muted" }, mayor: { label: "Mayor", tone: "warning" },
};

// ---------------- PROMPT 05 — REUNIONES ----------------
Object.assign(ACTIVITY_LABELS, {
  reunion_creada: "Reunión creada",
  serie_creada: "Serie de reuniones creada",
  agenda_item: "Punto de agenda añadido",
  reunion_abrir_preparacion: "Reunión en preparación",
  reunion_convocar: "Reunión convocada (invitaciones Outlook mock)",
  reunion_iniciar: "Reunión en curso",
  reunion_finalizar: "Reunión celebrada",
  reunion_cancelar: "Reunión cancelada",
  invitacion_respondida: "Invitación respondida",
  reunion_convocada: "Invitación a reunión",
  reunion_cancelada: "Reunión cancelada",
  seed_meetings: "Seed reuniones Hito 1",
});

// ---------------- PROMPT 05 HITO 2 — TRANSCRIPTS / IA GOBERNADA ----------------
Object.assign(ACTIVITY_LABELS, {
  transcript_recibido: "Transcript recibido",
  analisis_ia: "Análisis IA de transcript (candidatos)",
  candidato_confirmar: "Candidato confirmado por humano",
  candidato_corregir: "Candidato corregido por humano",
  candidato_rechazar: "Candidato rechazado",
  candidato_cambiar_categoria: "Categoría de candidato cambiada",
  candidato_asignar_responsable: "Responsable de candidato asignado",
  candidato_asignar_fecha: "Fecha de candidato asignada",
  candidato_relacionar_entidad: "Candidato relacionado con entidad",
  candidato_marcar_pendiente: "Candidato pospuesto",
  speaker_corregido: "Speaker de transcript corregido",
  validacion_cerrada: "Validación humana de transcript cerrada",
  umbrales_ia_actualizados: "Umbrales de confianza IA actualizados",
  seed_transcripts: "Seed transcripts Hito 2",
});

// ---------------- PROMPT 05 HITO 3 — ACTAS ----------------
export const MINUTE_STATUS = {
  no_generada: { label: "No generada", tone: "muted" },
  borrador_ia: { label: "Borrador IA", tone: "ai" },
  borrador_humano: { label: "Borrador humano", tone: "info" },
  requiere_informacion: { label: "Requiere información", tone: "warning" },
  en_revision: { label: "En revisión", tone: "warning" },
  cambios_solicitados: { label: "Cambios solicitados", tone: "warning" },
  preparada_aprobacion: { label: "Preparada para aprobación", tone: "info" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobada: { label: "Aprobada", tone: "success" },
  distribuida: { label: "Distribuida", tone: "success" },
  con_observaciones: { label: "Con observaciones", tone: "danger" },
  revisada: { label: "Revisada", tone: "info" },
  sustituida: { label: "Sustituida", tone: "muted" },
  archivada: { label: "Archivada", tone: "muted" },
};

export const RECIPIENT_STATUS = {
  pendiente: { label: "Pendiente", tone: "muted" },
  enviado: { label: "Enviado", tone: "info" },
  entregado: { label: "Entregado", tone: "info" },
  abierto: { label: "Abierto", tone: "info" },
  descargado: { label: "Descargado", tone: "info" },
  confirmado: { label: "Confirmado", tone: "success" },
  rebotado: { label: "Rebotado", tone: "danger" },
  error: { label: "Error", tone: "danger" },
};

export const OBJECTION_STATUS = {
  recibida: { label: "Recibida", tone: "danger" },
  en_revision: { label: "En revisión", tone: "warning" },
  aceptada: { label: "Aceptada", tone: "info" },
  rechazada: { label: "Rechazada", tone: "muted" },
  incorporada: { label: "Incorporada (nueva versión)", tone: "ai" },
  resuelta: { label: "Resuelta", tone: "success" },
  escalada: { label: "Escalada", tone: "danger" },
};

Object.assign(ACTIVITY_LABELS, {
  acta_borrador: "Borrador de acta generado desde fuentes validadas",
  acta_seccion_editar: "Sección de acta editada",
  acta_seccion_regenerar: "Sección de acta regenerada desde fuentes",
  acta_seccion_restaurar: "Sección de acta restaurada de versión anterior",
  acta_seccion_bloquear: "Sección de acta bloqueada",
  acta_seccion_desbloquear: "Sección de acta desbloqueada",
  acta_seccion_comentar: "Comentario en sección de acta",
  acta_seccion_marcar_incorrecto: "Sección de acta marcada incorrecta",
  acta_seccion_aprobar_seccion: "Sección de acta aprobada",
  acta_seccion_verificar_fuente: "Fuentes de sección verificadas",
  acta_enviar_revision: "Acta enviada a revisión",
  acta_solicitar_cambios: "Cambios solicitados en acta",
  acta_preparar_aprobacion: "Acta preparada para aprobación",
  acta_solicitar_aprobacion: "Aprobación de acta solicitada",
  acta_aprobada: "Acta aprobada (versión inmutable)",
  acta_aprobacion_rechazada: "Aprobación de acta rechazada",
  acta_aprobacion_parcial: "Aprobación parcial de acta (cadena)",
  acta_distribuir: "Acta distribuida",
  acta_distribuida: "Acta distribuida",
  acta_destinatario_abierto: "Acta abierta por destinatario",
  acta_destinatario_descargado: "Acta descargada por destinatario",
  acta_destinatario_confirmado: "Acta confirmada por destinatario (ack)",
  acta_destinatario_corregir_email: "Email de destinatario corregido",
  acta_destinatario_reenviar: "Acta reenviada a destinatario",
  acta_objecion: "Objeción sobre acta registrada",
  acta_objecion_revisar: "Objeción en revisión",
  acta_objecion_aceptar: "Objeción aceptada",
  acta_objecion_rechazar: "Objeción rechazada",
  acta_objecion_incorporar: "Objeción incorporada (nueva versión)",
  acta_objecion_escalar: "Objeción escalada",
  acta_objecion_resolver: "Objeción resuelta",
  acta_firma_preparada: "Firma de acta preparada",
  acta_firma_enviada: "Solicitud de firma de acta enviada",
  acta_firmada: "Acta firmada (certificado archivado)",
  acta_manipulacion_bloqueada: "Manipulación de acta bloqueada (inmutable)",
  acta_rebote: "Distribución de acta rebotada",
  acta_cambios: "Cambios solicitados en acta",
  acta_archivar: "Acta archivada",
  seed_minutes: "Seed actas Hito 3",
});

// ---------------- PROMPT 05 HITO 4 — SEGUIMIENTO ----------------
export const DECISION_EXEC_STATUS = {
  confirmada: { label: "Confirmada", tone: "info" },
  pendiente_ejecucion: { label: "Pendiente de ejecución", tone: "warning" },
  en_ejecucion: { label: "En ejecución", tone: "info" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
  ejecutada: { label: "Ejecutada (pendiente verificación)", tone: "ai" },
  verificada: { label: "Verificada", tone: "success" },
  sustituida: { label: "Sustituida", tone: "muted" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const DEP_KIND = {
  change_request: "Cambio de proyecto", contract_review: "Revisión contractual",
  purchase_request: "Solicitud de compra", financial_exception: "Excepción financiera",
  risk: "Riesgo", issue: "Incidencia", task: "Tarea", approval: "Aprobación",
  communication: "Comunicación", permit_action: "Acción de permiso", certification_review: "Revisión de certificación",
};

Object.assign(TASK_STATUS, {
  evidencia_aportada: "Evidencia aportada",
  cambios_solicitados: "Cambios solicitados",
});

export const MEETING_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  preparacion: { label: "En preparación", tone: "info" },
  convocada: { label: "Convocada", tone: "ai" },
  en_curso: { label: "En curso", tone: "warning" },
  celebrada: { label: "Celebrada", tone: "success" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

export const OPEN_QUESTION_STATUS = {
  abierta: { label: "Abierta", tone: "warning" },
  asignada: { label: "Asignada", tone: "info" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  respondida: { label: "Respondida (pendiente de validación)", tone: "ai" },
  validada: { label: "Validada", tone: "info" },
  cerrada: { label: "Cerrada", tone: "success" },
};

export const COMMITMENT_STATUS = {
  detectado: { label: "Detectado", tone: "muted" },
  vigente: { label: "Vigente", tone: "info" },
  validado: { label: "Validado", tone: "info" },
  pendiente: { label: "Pendiente", tone: "warning" },
  cumplido: { label: "Cumplido", tone: "success" },
  incumplido: { label: "Incumplido", tone: "danger" },
  en_revision_legal: { label: "En revisión legal", tone: "ai" },
  no_contractual: { label: "No contractual", tone: "muted" },
  convertido_obligacion: { label: "Convertido en obligación", tone: "success" },
  descartado: { label: "Descartado", tone: "muted" },
};

Object.assign(ACTIVITY_LABELS, {
  accion_reunion_iniciar: "Acción de reunión iniciada",
  accion_reunion_aportar_evidencia: "Evidencia aportada a acción de reunión",
  accion_reunion_enviar_revision: "Acción de reunión enviada a revisión",
  accion_reunion_aprobar_revision: "Revisión de acción aprobada",
  accion_reunion_devolver: "Acción devuelta con cambios",
  accion_reunion_reanudar: "Acción de reunión reanudada",
  accion_reunion_esperando_tercero: "Acción esperando a tercero",
  accion_reunion_bloquear: "Acción de reunión bloqueada",
  accion_reunion_desbloquear: "Acción de reunión desbloqueada",
  accion_reunion_cancelar: "Acción de reunión cancelada",
  accion_completada: "Acción de reunión completada con resultado",
  decision_exec_iniciar_ejecucion: "Ejecución de decisión iniciada",
  decision_exec_registrar_ejecucion: "Ejecución de decisión registrada",
  decision_exec_verificar: "Ejecución de decisión verificada",
  decision_exec_bloquear: "Ejecución de decisión bloqueada",
  decision_exec_desbloquear: "Ejecución de decisión desbloqueada",
  decision_exec_sustituir: "Decisión sustituida",
  decision_exec_cancelar: "Ejecución de decisión cancelada",
  proceso_dependiente_creado: "Proceso dependiente activado desde decisión",
  cuestion_asignar: "Cuestión asignada",
  cuestion_pedir_info: "Información solicitada para cuestión",
  cuestion_responder: "Cuestión respondida (pendiente de validación)",
  cuestion_validar: "Respuesta de cuestión validada",
  cuestion_solicitar_ampliacion: "Ampliación solicitada sobre cuestión",
  cuestion_cerrar: "Cuestión cerrada",
  compromiso_validar: "Compromiso validado",
  compromiso_marcar_pendiente: "Compromiso marcado pendiente",
  compromiso_registrar_cumplimiento: "Cumplimiento de compromiso registrado",
  compromiso_marcar_incumplido: "Compromiso incumplido",
  compromiso_enviar_revision_legal: "Compromiso enviado a revisión Legal",
  compromiso_clasificar_no_contractual: "Compromiso clasificado no contractual",
  compromiso_convertir_obligacion: "Compromiso convertido en obligación",
  reunion_reapertura_solicitada: "Reapertura excepcional solicitada",
  reunion_reabierta: "Reunión reabierta excepcionalmente",
  reunion_siguiente_preparada: "Siguiente reunión de la serie preparada",
  reunion_continuidad: "Pendientes arrastrados a la siguiente reunión",
  seguimiento_config: "Umbrales de escalación actualizados",
  accion_recordatorio: "Recordatorio de acción próxima a vencer",
  accion_vencida: "Acción de reunión vencida",
  accion_alerta: "Alerta de acción con retraso",
  accion_escalada: "Acción de reunión escalada a dirección",
  decision_verificacion: "Verificación de decisión solicitada",
  seed_followup: "Seed seguimiento Hito 4",
});

// ---------------- PROMPT 06 — GESTIÓN DOCUMENTAL ----------------
export const DOC6_STATUS = {
  recibido: { label: "Recibido", tone: "muted" },
  pendiente_clasificacion: { label: "Pendiente de clasificación", tone: "warning" },
  en_extraccion: { label: "En extracción", tone: "ai" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  borrador: { label: "Borrador", tone: "muted" },
  en_revision: { label: "En revisión", tone: "warning" },
  cambios_solicitados: { label: "Cambios solicitados", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  aprobado: { label: "Aprobado", tone: "success" },
  vigente: { label: "Vigente", tone: "success" },
  firmado: { label: "Firmado", tone: "success" },
  sustituido: { label: "Sustituido", tone: "muted" },
  caducado: { label: "Caducado", tone: "danger" },
  archivado: { label: "Archivado", tone: "muted" },
  bloqueado: { label: "Bloqueado", tone: "danger" },
  en_hold: { label: "En hold", tone: "danger" },
  pendiente_destruccion: { label: "Pendiente de destrucción", tone: "danger" },
  destruido_demo: { label: "Destruido (demo)", tone: "muted" },
  rechazado: { label: "Rechazado", tone: "muted" },
};

export const DUP6_STATUS = {
  detectado: { label: "Detectado", tone: "warning" },
  en_revision: { label: "En revisión", tone: "info" },
  confirmado: { label: "Confirmado", tone: "danger" },
  no_duplicado: { label: "No duplicado", tone: "muted" },
  version: { label: "Es versión", tone: "info" },
  copia: { label: "Es copia", tone: "info" },
  traduccion: { label: "Es traducción", tone: "info" },
  resuelto: { label: "Resuelto", tone: "success" },
  escalado: { label: "Escalado", tone: "danger" },
};

export const REPO6_STATUS = {
  no_configurado: { label: "No configurado", tone: "muted" },
  conectando: { label: "Conectando", tone: "info" },
  conectado: { label: "Conectado", tone: "success" },
  degradado: { label: "Degradado", tone: "warning" },
  error: { label: "Error", tone: "danger" },
  pausado: { label: "Pausado", tone: "muted" },
  desconectado: { label: "Desconectado", tone: "muted" },
};

export const DOCREQ_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  solicitada: { label: "Solicitada", tone: "info" },
  recibida: { label: "Recibida", tone: "ai" },
  en_revision: { label: "En revisión", tone: "warning" },
  aceptada: { label: "Aceptada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  vencida: { label: "Vencida", tone: "danger" },
  cancelada: { label: "Cancelada", tone: "muted" },
};

Object.assign(ACTIVITY_LABELS, {
  doc_ingerido: "Documento ingerido",
  doc_duplicado_detectado: "Duplicado documental detectado",
  doc_clasificar: "Documento clasificado",
  doc_validar: "Clasificación validada",
  doc_crear_version: "Nueva versión documental",
  doc_enviar_revision: "Documento enviado a revisión",
  doc_solicitar_cambios: "Cambios solicitados en documento",
  doc_solicitar_aprobacion: "Aprobación documental solicitada",
  doc_aprobar: "Documento aprobado",
  doc_rechazar: "Documento rechazado",
  doc_declarar_vigente: "Documento declarado vigente",
  doc_sustituir: "Documento sustituido",
  doc_archivar: "Documento archivado",
  doc_aplicar_hold: "Hold aplicado a documento",
  doc_retirar_hold: "Hold retirado",
  doc_solicitar_destruccion: "Destrucción documental solicitada",
  doc_aprobar_destruccion: "Destrucción documental aprobada (demo)",
  dup_declarar_copia: "Duplicado declarado copia",
  dup_declarar_version: "Duplicado declarado versión",
  dup_mantener_ambos: "Duplicados: mantener ambos",
  dup_seleccionar_canonico: "Canónico seleccionado",
  dup_archivar_copia: "Copia archivada",
  dup_escalar: "Duplicado escalado",
  solicitud_solicitar: "Solicitud documental enviada",
  solicitud_recibir: "Documento recibido en solicitud",
  solicitud_revisar: "Solicitud documental en revisión",
  solicitud_aceptar: "Solicitud documental aceptada",
  solicitud_rechazar: "Solicitud documental rechazada",
  solicitud_cancelar: "Solicitud documental cancelada",
  solicitud_reabrir: "Solicitud documental reabierta",
  repo_sync: "Repositorio sincronizado",
  seed_docs: "Seed documental P06",
});

// ---------------- PROMPT 06 — CORREO / SMART INBOX ----------------
export const MAIL6_STATUS = {
  nuevo: { label: "Nuevo", tone: "info" },
  clasificado: { label: "Clasificado", tone: "info" },
  en_gestion: { label: "En gestión", tone: "warning" },
  pendiente_respuesta: { label: "Pendiente de respuesta", tone: "danger" },
  esperando: { label: "Esperando tercero", tone: "muted" },
  archivado: { label: "Archivado", tone: "muted" },
  no_relevante: { label: "No relevante", tone: "muted" },
};

export const MAIL6_CAT = {
  factura: { label: "Factura", tone: "info" },
  contrato: { label: "Contrato", tone: "warning" },
  requerimiento_municipal: { label: "Requerimiento municipal", tone: "danger" },
  confirmacion: { label: "Confirmación", tone: "success" },
  cambio_bancario: { label: "Cambio bancario", tone: "danger" },
  poliza: { label: "Póliza", tone: "ai" },
  reunion: { label: "Reunión", tone: "info" },
  ambiguo: { label: "Ambiguo", tone: "muted" },
};

export const MAIL6_ATT = {
  sin_procesar: { label: "Sin procesar", tone: "warning" },
  candidato_duplicado: { label: "Posible duplicado", tone: "danger" },
  relacionado: { label: "Relacionado (sin copia)", tone: "success" },
  ingerido: { label: "Ingerido en documentos", tone: "info" },
};

export const MAIL6_CAND = {
  pendiente: { label: "Pendiente de confirmación", tone: "warning" },
  confirmada: { label: "Confirmada", tone: "success" },
  descartada: { label: "Descartada", tone: "muted" },
};

Object.assign(ACTIVITY_LABELS, {
  email_recibido: "Email recibido",
  email_clasificar: "Thread clasificado",
  email_confirmar_accion: "Acción de email confirmada",
  email_descartar_accion: "Acción de email descartada",
  email_confirmar_fecha: "Fecha límite de email confirmada",
  email_atender_fecha: "Fecha límite atendida",
  email_relacionar: "Thread relacionado con entidad",
  email_crear_expediente: "Expediente creado desde correo",
  email_usar_como_evidencia: "Email aportado como evidencia",
  email_preparar_respuesta: "Borrador de respuesta preparado",
  email_borrador: "Borrador de respuesta preparado",
  email_confirmar_envio: "Envío de email confirmado",
  email_enviado: "Email enviado (mock, confirmado por humano)",
  email_archivar: "Thread archivado",
  email_marcar_no_relevante: "Thread marcado no relevante",
  email_procesar_adjunto: "Adjunto de email procesado",
  email_adjunto_duplicado: "Adjunto duplicado detectado",
  email_adjunto_ingerido: "Adjunto ingerido en documentos",
  email_adjunto_relacionado: "Adjunto relacionado sin copia",
  tarea_creada_email: "Tarea creada desde correo",
  seed_mail: "Seed correo P06",
});

// ---------------- PROMPT 06 — PÓLIZAS ----------------
export const POL6_STATUS = {
  recibida: { label: "Recibida", tone: "muted" },
  en_extraccion: { label: "En extracción", tone: "ai" },
  pendiente_validacion: { label: "Pendiente de validación", tone: "warning" },
  en_revision: { label: "En revisión", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  vigente: { label: "Vigente", tone: "success" },
  proxima_vencer: { label: "Próxima a vencer", tone: "warning" },
  en_renovacion: { label: "En renovación", tone: "info" },
  sustituida: { label: "Sustituida", tone: "muted" },
  caducada: { label: "Caducada", tone: "danger" },
  cancelada: { label: "Cancelada", tone: "muted" },
  bloqueada: { label: "Bloqueada", tone: "danger" },
};
export const POL6_GAP_SEV = {
  critica: { label: "Crítica", tone: "danger" }, alta: { label: "Alta", tone: "danger" },
  media: { label: "Media", tone: "warning" }, baja: { label: "Baja", tone: "muted" },
};
export const POL6_GAP_STATUS = {
  abierto: { label: "Abierto", tone: "danger" }, en_tratamiento: { label: "En tratamiento", tone: "warning" },
  resuelto: { label: "Resuelto", tone: "success" }, riesgo_aceptado: { label: "Riesgo aceptado", tone: "muted" },
};
export const POL6_REN_STATUS = {
  abierta: { label: "Abierta", tone: "warning" }, en_curso: { label: "En curso", tone: "info" },
  oferta_recibida: { label: "Oferta recibida", tone: "info" }, en_comparacion: { label: "En comparación", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  completada: { label: "Completada", tone: "success" }, no_renovada: { label: "No renovada", tone: "muted" },
};

// ---------------- PROMPT 06 — VACACIONES ----------------
export const VAC6_STATUS = {
  borrador: { label: "Borrador", tone: "muted" },
  pendiente_confirmacion: { label: "Pendiente de confirmación", tone: "warning" },
  solicitada: { label: "Solicitada", tone: "info" },
  pendiente_informacion: { label: "Pendiente de información", tone: "warning" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", tone: "ai" },
  cambios_solicitados: { label: "Cambios solicitados", tone: "warning" },
  aprobada: { label: "Aprobada", tone: "success" },
  rechazada: { label: "Rechazada", tone: "danger" },
  modificacion_solicitada: { label: "Modificación solicitada", tone: "warning" },
  cancelacion_solicitada: { label: "Cancelación solicitada", tone: "warning" },
  cancelada: { label: "Cancelada", tone: "muted" },
  registrada_calendario: { label: "Registrada en calendario", tone: "success" },
  finalizada: { label: "Finalizada", tone: "muted" },
};
export const VAC6_CONFLICT = {
  informativo: { label: "Informativo", tone: "info" },
  advertencia: { label: "Advertencia", tone: "warning" },
  bloqueo: { label: "Bloqueo", tone: "danger" },
};

Object.assign(ACTIVITY_LABELS, {
  poliza_extraer: "Extracción de póliza (IA mock)",
  poliza_proponer_validacion: "Extracción de póliza propuesta para validación",
  poliza_validar: "Extracción de póliza validada",
  poliza_solicitar_aprobacion: "Aprobación de póliza solicitada",
  poliza_aprobar: "Póliza aprobada y vigente",
  poliza_rechazar_aprobacion: "Aprobación de póliza rechazada",
  poliza_iniciar_renovacion: "Renovación de póliza iniciada",
  poliza_sustituir: "Póliza sustituida",
  poliza_marcar_caducada: "Póliza caducada",
  poliza_cancelar: "Póliza cancelada",
  poliza_bloquear: "Póliza bloqueada",
  poliza_desbloquear: "Póliza desbloqueada",
  gap_detectado: "Gap de cobertura detectado",
  gap_resuelto: "Gap de cobertura resuelto",
  endorsement_creado: "Endorsement registrado",
  endorsement_aceptado: "Endorsement aceptado (gaps recalculados)",
  renovacion_abierta: "Renovación de póliza abierta",
  renovacion_completada: "Renovación de póliza completada",
  vacaciones_creadas: "Solicitud de ausencia creada",
  vacaciones_solicitar: "Aprobación de ausencia solicitada",
  vacaciones_confirmar_empleado: "Ausencia confirmada por el empleado",
  vacaciones_aprobar: "Ausencia aprobada (calendario + delegación)",
  vacaciones_rechazar: "Ausencia rechazada",
  vacaciones_solicitar_cambios: "Cambios solicitados en ausencia",
  vacaciones_solicitar_modificacion: "Modificación de ausencia solicitada",
  vacaciones_aprobar_modificacion: "Modificación de ausencia aprobada",
  vacaciones_solicitar_cancelacion: "Cancelación de ausencia solicitada",
  vacaciones_aprobar_cancelacion: "Cancelación de ausencia aprobada",
  vacaciones_rechazar_modificacion: "Modificación/cancelación rechazada",
  vacaciones_solicitar_informacion: "Información solicitada sobre ausencia",
  vacaciones_responder_informacion: "Información aportada sobre ausencia",
  delegacion_creada: "Delegación creada",
  vacaciones_aprobadas: "Ausencia aprobada",
  vacaciones_rechazadas: "Ausencia rechazada",
  vacaciones_canceladas: "Ausencia cancelada",
  poliza_caducada: "Póliza caducada",
  seed_pav: "Seed pólizas y vacaciones P06",
});

// ---------------- PROMPT 06 — CUADRO CORPORATIVO ----------------
export const SIG6_STATUS = {
  nuevo: { label: "Nuevo", tone: "danger" },
  reconocido: { label: "Reconocido", tone: "info" },
  asignado: { label: "Asignado", tone: "info" },
  en_tratamiento: { label: "En tratamiento", tone: "warning" },
  pospuesto: { label: "Pospuesto", tone: "muted" },
  resuelto_en_origen: { label: "Resuelto en origen", tone: "success" },
  cerrado: { label: "Cerrado", tone: "muted" },
  falso_positivo: { label: "Falso positivo", tone: "muted" },
};
export const SIG6_SEV = {
  critica: { label: "Crítica", tone: "danger" }, alta: { label: "Alta", tone: "danger" },
  media: { label: "Media", tone: "warning" }, baja: { label: "Baja", tone: "muted" },
};
export const RUN6_STATUS = {
  pending: { label: "Pendiente", tone: "muted" }, running: { label: "En ejecución", tone: "info" },
  completed: { label: "Completada", tone: "success" }, completed_warnings: { label: "Completada con avisos", tone: "warning" },
  failed: { label: "Fallida", tone: "danger" }, retrying: { label: "Reintentando", tone: "info" },
  dead_letter: { label: "Dead letter", tone: "danger" }, cancelled: { label: "Cancelada", tone: "muted" },
};

Object.assign(ACTIVITY_LABELS, {
  senal_reconocer: "Señal reconocida",
  senal_asignar: "Señal asignada",
  senal_crear_tarea: "Tarea creada desde señal",
  senal_tarea_creada: "Tarea creada desde señal",
  senal_posponer: "Señal pospuesta",
  senal_comentar: "Comentario en señal",
  senal_falso_positivo: "Señal descartada (falso positivo)",
  senal_override_prioridad: "Prioridad de señal modificada (override)",
  senal_resolver: "Señal resuelta",
  automatizacion_ejecutada: "Automatización ejecutada",
  automatizacion_reintentada: "Automatización reintentada",
  seed_corp: "Seed cuadro corporativo P06",
});

// ---------------- DEMO RELEASE 1 — EXECUTIVE SUMMARIES ----------------
export const SUM6_STATUS = {
  draft: { label: "Borrador", tone: "muted" },
  generated: { label: "Generado", tone: "info" },
  needs_review: { label: "Requiere revisión", tone: "warning" },
  in_review: { label: "En revisión", tone: "ai" },
  approved: { label: "Aprobado (inmutable)", tone: "success" },
  superseded: { label: "Sustituido", tone: "muted" },
};
export const SUM6_STMT = {
  FACT: { label: "FACT", tone: "success" },
  ANALYSIS: { label: "ANALYSIS", tone: "info" },
  ASSUMPTION: { label: "ASSUMPTION", tone: "warning" },
  RECOMMENDATION: { label: "RECOMMENDATION", tone: "ai" },
  UNVERIFIED: { label: "UNVERIFIED", tone: "danger" },
};

Object.assign(ACTIVITY_LABELS, {
  summary_generado: "Executive summary generado",
  summary_enviar_revision: "Summary enviado a revisión",
  summary_devolver: "Summary devuelto a generación",
  summary_aprobar: "Summary aprobado (versión inmutable)",
  summary_stmt_validar: "Afirmación de summary validada",
  summary_stmt_editar_wording: "Redacción de afirmación editada",
  summary_stmt_reclasificar: "Afirmación reclasificada",
  summary_stmt_solicitar_fuente: "Fuente solicitada para afirmación",
  summary_stmt_rechazar: "Afirmación rechazada",
  summary_stmt_restaurar: "Afirmación restaurada",
  summary_stmt_comentar: "Comentario en afirmación",
});
